import React, { useState } from 'react'; // Import useState hook
import './mainmenu.css'; // Importing the CSS for styling

const MainMenu = ({ setActiveComponent }) => {
  // State to track the currently active component
  const [activeComponent, setActive] = useState('workOrderList');

  // Function to handle menu item click
  const handleMenuItemClick = (componentName) => {
    setActiveComponent(componentName); // Update the parent component's active component
    setActive(componentName); // Update the local active component state
  };

  return (
    
      <div className='menu'>
        <div className={`menu-item ${activeComponent === 'workOrderList' ? 'active' : ''}`} onClick={() => handleMenuItemClick('workOrderList')}>Work Orders</div>
        <div className={`menu-item ${activeComponent === 'scheduling' ? 'active' : ''}`} onClick={() => handleMenuItemClick('scheduling')}>Scheduling</div>
        <div className={`menu-item ${activeComponent === 'archived' ? 'active' : ''}`} onClick={() => handleMenuItemClick('archived')}>Archived</div>
        
      </div>
      
    
  );
};
 
export default MainMenu;

 